import React from 'react';
import { colors } from '../../../theme/modules/colors';
import { IconWrap, Toast as ToastContainer, StyledText as Text, ContentStack } from './styled';
import { buildClassnames } from '../../../utils/buildClassnames';
import { Button } from '../../Button';
import { SuccessIcon } from '../../../tempIcons/SuccessIcon';
import { InfoIcon } from '../../../tempIcons/InfoIcon';
import { AttentionIcon } from '../../../tempIcons/AttentionIcon';
import { MergeIcon } from '../../../tempIcons/MergeIcon';
import { CrossIcon } from '../../../tempIcons/CrossIcon';
const toastTypes = {
    info: {
        accentColor: colors.brand.blue.base,
        icon: React.createElement(InfoIcon, null),
    },
    success: {
        accentColor: colors.secondary.green.base,
        icon: React.createElement(SuccessIcon, null),
    },
    error: {
        accentColor: colors.secondary.red.base,
        icon: React.createElement(AttentionIcon, null),
    },
    merge: {
        accentColor: colors.secondary.purple.base,
        icon: React.createElement(MergeIcon, null),
    },
};
const generateClassNames = (prefix) => ({
    container: prefix ? `${prefix}-toast-container` : undefined,
    icon: prefix ? `${prefix}-toast-icon` : undefined,
    closeIcon: prefix ? `${prefix}-toast-close-icon` : undefined,
});
export const Toast = ({ className, e2eClassName, type, iconSlot, text, last, minWidth, cta, onClose, }) => {
    const classNames = generateClassNames(className);
    const e2eClassNames = generateClassNames(e2eClassName);
    return (React.createElement(ToastContainer, { className: buildClassnames([classNames === null || classNames === void 0 ? void 0 : classNames.container, e2eClassNames === null || e2eClassNames === void 0 ? void 0 : e2eClassNames.container]), direction: "horizontal", alignY: "center", minWidth: minWidth, last: last },
        React.createElement(IconWrap, { color: toastTypes[type].accentColor, className: buildClassnames([classNames.icon, e2eClassNames.icon]) }, iconSlot !== null && iconSlot !== void 0 ? iconSlot : toastTypes[type].icon),
        React.createElement(ContentStack, { direction: "horizontal", alignY: "center", alignX: "between" },
            React.createElement(Text, { variant: "body" }, text),
            cta),
        React.createElement(Button, { variant: "flat", icon: React.createElement(CrossIcon, { color: "white" }), onClick: onClose, "aria-label": "Close" })));
};
//# sourceMappingURL=Toast.js.map